import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "@/shared/layouts/auth-layout";
import { OAuthConsentPage } from "@/shared/pages/oauth/consent-page";

export const Route = createFileRoute("/oauth/consent")({
  component: OAuthConsentRoute,
});

function OAuthConsentRoute() {
  return (
    <AuthLayout>
      <OAuthConsentPage />
    </AuthLayout>
  );
}
